module.exports = __webpack_public_path__ + "static/media/loosing_1.0e3abc96.mp3";